export const normalizeStockSearch = (value = "") => {
  const upper = value.toLocaleUpperCase("tr-TR").trimStart();
  const exact = upper.trimEnd().endsWith(",");
  const body = exact ? upper.trimEnd().slice(0, -1).trim() : upper;
  const normalizedBody = body.replace(/\s{2,}/g, " ");
  return exact ? `${normalizedBody.trim()},` : normalizedBody;
};

export const normalizePastedStockSearch = (value = "") => {
  const upper = value.toLocaleUpperCase("tr-TR").trim();
  const exact = upper.endsWith(",");
  const body = exact ? upper.slice(0, -1) : upper;
  const normalizedBody = body.replace(/\s+/g, "");
  return exact ? `${normalizedBody},` : normalizedBody;
};

export const applyPastedStockSearch = (current = "", pasted = "", start, end) => {
  const from = Number.isInteger(start) ? start : current.length;
  const to = Number.isInteger(end) ? end : from;
  const compactPaste = normalizePastedStockSearch(pasted);
  return normalizeStockSearch(`${current.slice(0, from)}${compactPaste}${current.slice(to)}`);
};

// Result grouping compares identifiers canonically; this must not rewrite what
// the user typed or what is sent to the search API.
export const canonicalStockSearch = (value = "") => {
  const normalized = normalizeStockSearch(value);
  const exact = normalized.endsWith(",");
  const body = exact ? normalized.slice(0, -1) : normalized;
  const canonicalBody = /\d/.test(body) ? body.replace(/\s+/g, "") : body;
  return exact ? `${canonicalBody},` : canonicalBody;
};

export const meaningfulSearchLength = (value = "") =>
  normalizeStockSearch(value).replace(/[\s,]/g, "").length;

export const isStockSearchReady = (value = "", minimum = 6) => {
  const normalized = normalizeStockSearch(value).replace(/,$/, "").trim();
  return meaningfulSearchLength(normalized) >= minimum;
};

export const isStockSearchSubmitReady = (value = "") => isStockSearchReady(value, 3);

const RECENT_KEY = "vagenpar.recent-stock-searches";

export const getRecentStockSearches = () => {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); }
  catch { return []; }
};

export const rememberStockSearch = (value = "") => {
  const query = normalizeStockSearch(value).trim();
  if (!isStockSearchSubmitReady(query)) return;
  const next = [query, ...getRecentStockSearches().filter((item) => item !== query)].slice(0, 10);
  localStorage.setItem(RECENT_KEY, JSON.stringify(next));
};

export const clearRecentStockSearches = () => localStorage.removeItem(RECENT_KEY);
